import React, {useState, useEffect, useContext} from "react";
import { AppContext } from '../ApplicationContext';

export interface IUrlPreview {
    link: string;
}

export const UrlPreview =  (props:IUrlPreview) => {

    const context = useContext(AppContext);

    
    const [metadata, setMetadata] = useState(null);

    const [prefix, setPrefix] = useState("");

    const onFailedIcon = (e) => {
    
        $(e.nativeEvent.target).parent().hide();

    }

    useEffect( ()=>{

        if(metadata){
            return;
        }

        let url = props.link;

        if(url.toLowerCase().startsWith("www.")) {
            url = "https://" + url;
            setPrefix("https://");
        }

        const IS_EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        if(url.match(IS_EMAIL_REGEX)) {
            
            console.log("Preview: email address");

            if(!url.startsWith("mailto")) {
                setPrefix("mailto:");
            }

        }  else {

        context.messenger

            .urlPreview(url)

                .then((result)=>{

                    console.log("server",{url:url, result:result});

                    var html = document.createElement('html');
                    html.innerHTML  = result;

                    let title = $('head > title', html).first().text();
                    let metaDescription = $('head > meta[name="description"]', html).first().text();
                    let metaAuthor = $('head > meta[name="author"]', html).first().text();
                    let icon = $('head > link[rel="icon"]', html).first().attr("href");
                    //console.log(icon);
                    if(!icon) {
                        icon = $('head > link[rel="shortcut icon"]', html).first().attr("href");
                    }
                    //console.log(icon);
                    if(!icon) {
                        icon = $('head > meta[itemprop="image"]', html).first().attr("content");
                    }
                    
                    
                    let parsedUrl = null
                    try{parsedUrl = new URL(url);} catch(err){};

                    let baseUrl = parsedUrl ? parsedUrl.protocol +"//" + parsedUrl.host : "";
                    let displayName = (!parsedUrl) ? title : parsedUrl.protocol +"//" + parsedUrl.host; 


                    console.log("icon",{icon:icon, baseUrl:baseUrl});
                    if(icon && !icon.startsWith("http")) {
                        icon = baseUrl + icon;
                    }

                    let md = {title:title,description:metaDescription, author:metaAuthor, icon:  icon, url: parsedUrl, displayName:displayName};
                    
                    //console.log("html",{metadata:md, url:url, html:html, j:$(html), title: $('head > title', html)});


                    console.log("UrlPreview", {metadata:md});
                    setMetadata(md);

                })
                .catch((err)=>
                {
                    console.log("server",{err:err,url:url})
                });
            }          
    },[]);


    return <>
    
    { !metadata && <a className="mr-link" href={prefix + props.link} target='_blank' rel="noopener noreferrer">{props.link}</a>}
    { metadata  && <div className="mr-link" >
                            <div className="card">
                            <div className="row align-items-center">
                                
                                 {metadata.icon && <div className="col col-auto "><img onError={onFailedIcon} src={metadata.icon} className="card-img-top m-4 mr-link-preview-logo" alt={metadata.description}/></div> }
                            
                           <div className="col">
                             <div className="card-body">
                             
                                <p className="card-title">{metadata.title}</p>
                                <p className="card-text">{metadata.description}</p> 
                              
                                <a href={prefix + props.link} className="card-link"  target='_blank' rel="noopener noreferrer">{metadata.displayName} <i className="bi bi-link"></i></a>
                              </div>
                           </div> {/* col */}
                           
                           </div> {/* row */}
                  </div> {/* card */}
                  </div>  
    }
    </>


}